module.exports = __webpack_public_path__ + "img/mes-cover.6e973225.jpg";